import { trpc } from '@/shared/api';

export const useInvalidatePortfolios = () => {
  const utils = trpc.useUtils();
  return () => {
    void utils.portfolioManagement.items.list.invalidate();
    void utils.portfolioManagement.items.get.invalidate();
    void utils.portfolioManagement.categories.list.invalidate();
  };
};
